import { useState } from 'react';

import { MoreDetails, MoreDetailsToggle } from '../Account.styles';
import { getGuestSummaryString } from '../helpers/getGuestSummaryString';
import { MappedOrderItem } from '../helpers/mapOrderDetails.helper';

type MobileMoreDetailsProps = {
  item: MappedOrderItem;
};

export function MobileMoreDetails({ item }: MobileMoreDetailsProps) {
  const [moreDetailsExpanded, setMoreDetailsExpanded] = useState(false);

  return (
    <MoreDetails isExpanded={moreDetailsExpanded}>
      <MoreDetailsToggle onClick={() => setMoreDetailsExpanded((val) => !val)}>
        More details
      </MoreDetailsToggle>
      <div>{getGuestSummaryString(item.adults, item.children, item.guests)}</div>
      {item.rate ? <div>{item.rate}</div> : <></>}
      {item.extras.length ? <span>{item.extras.join(', ')}</span> : <></>}
    </MoreDetails>
  );
}
